
export const DEMO_BASE_PATH = "/d";